import { ISportsBettingBaseApi, ReportedProblemType } from '../api/apiBase';
import { IGroupedApi } from '../api/apiCommon';
import { ICommonAppSettings } from '../models';
import { ILoggingService } from './loggingService';

export interface ITelemetryService {
    logAjaxRequest(type: TelemetryServiceDataType, userId: number, start: Date, userData: string): void;
    logAjaxFailedRequest(type: TelemetryServiceDataType, userId: number, start: Date, userData: string, error: any): void;
}

export enum TelemetryServiceDataType {
    CouponReset = "CouponReset",
    CouponStake = "CouponStake",
    CouponProduct = "CouponProduct",
    GetCoupon = "GetCoupon",
    GetCouponWithAdd = "GetCouponWithAdd",
    SaveCoupon = "SaveCoupon",
    SendCouponAcceptation = "SendCoupAcc",
    CouponPay = "CouponPay",
    SendAlarmsOnCouponIsOk = "AlarmsIsOk",
    SendCouponPayWithHint = "CouponPayWithHint",
    CashOutSubmit = "CashOutSubmit",
    CancelBet = "CancelBet",
    VideoShown = "VideoShown",
    MatchTrackerShown = "MatchTrackerShown"
}

export class TelemetryService implements ITelemetryService {

    private settings: ICommonAppSettings;
    private loggingService: ILoggingService;
    private sbApi: IGroupedApi<ISportsBettingBaseApi>;

    public constructor(settings: ICommonAppSettings, loggingService: ILoggingService, sbApi: IGroupedApi<ISportsBettingBaseApi>) {
        this.settings = settings;
        this.sbApi = sbApi;
        this.loggingService = loggingService;
    }

    public logAjaxRequest(type: TelemetryServiceDataType, userId: number, start: Date, userData: string): void {
        this.logAjaxRequestRaw(type, userId, start, true, userData, null);
    }

    public logAjaxFailedRequest(type: TelemetryServiceDataType, userId: number, start: Date, userData: string, error: any): void {
        this.logAjaxRequestRaw(type, userId, start, false, userData, error);
    }

    public logAjaxRequestRaw(type: TelemetryServiceDataType, userId: number, start: Date, isSuccess: boolean, userData: string, error: any): void {
        try {
            var intervalMs = Math.max(0, new Date().getTime() - start.getTime());
            var page = this.getPage();
            var detail = error ? error.message : null;

            let ctx = this.sbApi.open();
            try {
                let text;
                if (detail) {
                    text = "ajaxRequest;" + type + ";" + userId + ";" + (isSuccess ? 1 : 0) + ";" + intervalMs + ";" + userData + ";" + page + ";" + detail;
                }
                else {
                    text = "ajaxRequest;" + type + ";" + userId + ";" + (isSuccess ? 1 : 0) + ";" + intervalMs + ";" + userData + ";" + page + ";";
                }
                ctx.api.reportInfoToServer(ReportedProblemType.Warning, text);
            }
            finally {
                ctx.close();
            }
        }
        catch (e) {
            this.loggingService.error(e);
            if (this.settings.isDebug) {
                throw e;
            }
        }
    }

    private getPage(): string {
        let href = window.location.href;
        var slashesPos = href.indexOf("//");
        if (slashesPos > 0) {
            var pos = href.indexOf("/", slashesPos + 2);
            if (pos > 0) {
                return href.substring(pos);
            }
        }
        return href;
    }
}